import {Construtor} from './construtor';
import {ProcessoSetor} from './processo-setor';
import {Setor} from './setor';
import {PontoFisico} from './ponto-fisico';

export class SetorPontoFisico implements Construtor<SetorPontoFisico> {

  public idSetorPontoFisico: number;
  public idSetorCliente: number;
  public pontoFisico: PontoFisico;
  public setor: Setor;
  public selecionado: boolean;
  public alterado: boolean;
  public visible: boolean;

  constructor(object?: any) {

    this.visible = false;
    this.setor = new Setor();
    this.pontoFisico = new PontoFisico();

    if (object !== undefined) {
      if (object instanceof (SetorPontoFisico)) {
        this.copyObject(object);
      } else if (object instanceof (Setor)) {
        this.setor = object;
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  set IdSetorPontoFisico(id: any) {
    this.idSetorPontoFisico = id;
  }

  set IdSetorCliente(id: any) {
    this.idSetorCliente = id;
  }

  set PontoFisico(id: any) {
    this.pontoFisico = id;
  }

  set Setor(setor: any) {
    this.setor = new Setor(setor);
  }

  parseFromJson(setorPontoFisico: any): void {
    this.IdSetorPontoFisico = setorPontoFisico.idSetorPontoFisico;
    this.IdSetorCliente = setorPontoFisico.idSetorCliente;
    this.PontoFisico = setorPontoFisico.pontoFisico;
    this.Setor = setorPontoFisico.setor;
  }

  copyObject(setorPontoFisico: SetorPontoFisico): void {
    this.idSetorPontoFisico = setorPontoFisico.idSetorPontoFisico;
    this.idSetorCliente = setorPontoFisico.idSetorCliente;
    this.pontoFisico = setorPontoFisico.pontoFisico;
    this.setor = setorPontoFisico.setor;
  }

  modeloCompleto(): boolean {
    return this.setor.modeloCompleto();
  }

  getNewInstance(object?: any): SetorPontoFisico {
    return new SetorPontoFisico(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/setor-ponto-fisico.ts